if (!customElements.get('beds-price-total')) {
  customElements.define(
    'beds-price-total',
    class BedsPriceTotal extends HTMLElement {
      connectedCallback() {
        this.priceElement = this.querySelector('[data-beds-total-price]');
        this.moneyFormat = this.dataset.moneyFormat;
        this.variantPrice = Number(this.dataset.variantPrice) || 0;

        this.variantSelector = document.querySelector(`beds-variant-selector[data-section="${this.dataset.section}"]`);
        this.addons = document.querySelector(`beds-addons[data-section-id="${this.dataset.section}"]`);

        // beds-variant-selector and beds-addons live outside this element's subtree,
        // so the bubbled event is only reachable via a document-level listener.
        this.boundRecalculate = this.recalculate.bind(this);
        document.addEventListener('beds:selection-change', this.boundRecalculate);

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId !== this.dataset.section || !event.data.variant) return;
          this.variantPrice = Number(event.data.variant.price) || 0;
          this.recalculate();
        });
      }

      disconnectedCallback() {
        document.removeEventListener('beds:selection-change', this.boundRecalculate);
        this.variantChangeUnsubscriber?.();
      }

      recalculate() {
        if (!this.priceElement) return;

        const basePrice = this.variantSelector?.getSelectedBasePrice?.() || 0;
        const addonsTotal = this.addons?.getSelectedTotal?.() || 0;
        const total = this.variantPrice + basePrice + addonsTotal;

        this.priceElement.textContent = formatMoney(total, this.moneyFormat);
      }
    }
  );
}

function formatMoney(cents, format) {
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const defaultFormat = '${{amount}}';

  function formatWithDelimiters(number, precision = 2, thousands = ',', decimal = '.') {
    if (isNaN(number) || number == null) return 0;

    const numberValue = (number / 100).toFixed(precision);
    const parts = numberValue.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
    const cents = parts[1] ? decimal + parts[1] : '';

    return dollars + cents;
  }

  let value = '';
  const formatString = format || defaultFormat;

  switch (formatString.match(placeholderRegex)?.[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }

  return formatString.replace(placeholderRegex, value);
}
